import { UIPalette } from './uiPalete.type'

const error = {
  main: '#B31B32',
  dark: '#90112F',
  light: '#FEF3EA',
  contrast: '#FFFFFF',
  outlinedBorder: '#B31B324D',
  border: '#B31B32',
}

const warning = {
  main: '#CD6B00',
  dark: '#AC5200',
  light: '#FEF9E5',
  contrast: '#FFFFFF',
  outlinedBorder: '#CD6B004D',
  border: '#CD6B00',
}

const info = {
  main: '#0149B5',
  dark: '#002478',
  light: '#E5F8FE',
  contrast: '#FFFFFF',
  outlinedBorder: '#0149B54D',
  border: '#0149B5',
}

const none = {
  main: '#00000099',
  dark: '#000000',
  light: '#b3b3b3',
  contrast: '#FFFFFF',
  outlinedBorder: '#000000',
  border: '#00000099',
}

export const MUI_PALETTE: UIPalette = {
  blueGrey100: '#DCE2EF',
  blueGrey700: '#4E5769',
  blueGrey800: '#343E52',
  blueGrey900: '#1C273E',
  blue700: '#0033A0',
  blue900: '#00185C',
  blue100: '#CCE5FF',

  grey50: '#F7F7F7',
  border: '#0000001F',

  divider: '#0000001e',

  button: {
    main: '#0033A0',
    dark: '#002375',
  },
  primary: {
    main: '#0D58D9',
    dark: '#0644B8',
    light: '#3E84ED',
    contrast: '#FFFFFF',
    hover: '#0D58D90A',
    selected: '#0D58D914',
    focus: '#0D58D91F',
    focusVisible: '#0D58D933',
    outlinedBorder: '#0D58D94D',
  },

  text: {
    primary: '#000000', // should be #000000CC
    secondary: '#00000099',
    disabled: '#00000066', // should be #0000006B
  },

  error,
  warning,
  info,

  success: {
    main: '#11732E',
    dark: '#064C28',
    light: '#F1FFEB',
    contrast: '#FFFFFF',
    outlinedBorder: '#11732E4D',
    border: '#11732E',
  },

  action: {
    active: '#0000008F',
    hover: '#0000000A',
    selected: '#00000014',
    diasbeldBackround: '#0000001F',
    focus: '#0000001F',
    disabled: '#00000061',
    readOnly: '#EEEEEE',
  },

  white: {
    main: '#FFFFFF',
    selected: '#FFFFFF14',
    outlinedBorder: '#FFFFFF4D',
  },

  grey: {
    main: '#0D58D9',
    dark: '#0644B8',
    light: '#3E84ED',
    contrast: '#FFFFFF',
    hover: '#0D58D90A',
    selected: '#0D58D914',
    focus: '#0D58D91F',
    focusVisible: '#0D58D933',
    outlinedBorder: '#0D58D94D',
    resizer: '#989898',
    cardBorder: '#C2C3CC',
    label: '#575966',
  },

  validation: {
    error,
    warning,
    info,
    none,
  },

  components: {
    form: {
      background: '#FFFFFF',

      group: {
        background: '#FFFFFF',
      },
    },
    input: {
      readonlyBorder: '#EEEEEE',
      enabledBorder: '#0000003B',
      hoverBorder: '#000000',
      background: '#FFFFFF',
    },
    modal: {
      background: '#FFFFFF',
    },
    tooltip: {
      fill: '#616161E5',
    },
    navigation: {
      main: '#6A768F',
      dark: '#39496A',
    },
    tab: {
      content: {
        background: '#F7F7F7',
      },
    },
    table: {
      background: '#FFFFFF',
    },
    viewContent: {
      background: '#F7F7F7',
    },
  },

  logs: {
    delete: '#FFD1D8',
    deleteLight: '#FFEBEE',
    add: '#A9EEAA',
    addLight: '#DFFAE4',
    change: '#CD6B00',
    changeLight: '#FEF9E5',
    empty: '#BCC5D5',
    emptyLight: '#F4F7FB',
  },
}
